import { extendTheme } from '@chakra-ui/react';

import { Button } from './button';
import { Select } from './select';

const colors = {
  brand: {
    50: '#F5F9FF',
    100: '#c0d6e8',
    200: '#6BD87F',
    300: '#6BD87F',
    400: '#00A81F',
    500: '#1A843E',
    600: '#007E62',
    700: '#000f26',
    800: '#000f26',
    900: '#000f26',
  },
};

const customTheme = extendTheme({
  colors,
  fonts: {
    body: 'Rubik, Times New Roman, sans-serif',
    heading: 'balboa, Rubik, Times New Roman, sans-serif',
    mono: 'Rubik, Times New Roman, sans-serif',
  },
  components: {
    Button,
    Select,
  },
});

export default customTheme;
